import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                VRow,
                [
                  _c("select-multiple-unidades", {
                    attrs: { "mapeamento-id": _vm.diagnostico.mapeamento.id },
                    model: {
                      value: _vm.unidades,
                      callback: function ($$v) {
                        _vm.unidades = $$v
                      },
                      expression: "unidades",
                    },
                  }),
                ],
                1
              ),
              _vm.unidades.selecionado.length
                ? _c(
                    "div",
                    [
                      _vm.desempenhosUnidadesViabilizados.length
                        ? _c(
                            "div",
                            [
                              _c(
                                VRow,
                                [
                                  _c(
                                    VCol,
                                    [
                                      _c("pie-chart-categoria-c-d-s", {
                                        attrs: {
                                          desempenhos:
                                            _vm.desempenhosUnidadesViabilizados,
                                          fonte: _vm.fontePieChart,
                                          titulo: _vm.tituloPieChart,
                                          "com-sub-piechart": "",
                                          "is-get-svg": _vm.isGetSvg,
                                        },
                                        on: {
                                          svg: (value) => (_vm.svg = value),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.unidadesInviabilizadas.length > 0
                                ? _c(
                                    VRow,
                                    { staticClass: "justify-center" },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "caption text-center" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.msgUnidadesInviabilizadas
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                VRow,
                                { staticClass: "justify-center" },
                                [_c("legenda-cds")],
                                1
                              ),
                              _c(
                                VRow,
                                [
                                  _c(
                                    VCol,
                                    [
                                      _c("tabela-resultados-c-d-s", {
                                        attrs: {
                                          dados: _vm.dadosTabelaCds,
                                          "is-uma-unidade": false,
                                          titulo: _vm.tituloTabelaResultados,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.unidadesInviabilizadas.length > 0
                                ? _c(
                                    VRow,
                                    [
                                      _c(
                                        VCol,
                                        [
                                          _c(VDataTable, {
                                            attrs: {
                                              headers:
                                                _vm.headerTabelaInviabilizados,
                                              items: _vm.unidadesInviabilizadas,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "top",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        VRow,
                                                        { staticClass: "mb-2" },
                                                        [
                                                          _c(
                                                            VToolbar,
                                                            {
                                                              attrs: {
                                                                flat: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                VToolbarTitle,
                                                                [
                                                                  _c(
                                                                    "h2",
                                                                    {
                                                                      staticClass:
                                                                        "title primary--text text--darken-1 text-no-wrap",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.tituloTabelaInviabilizadas
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              2112000427
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                VRow,
                                { staticClass: "justify-end mb-1" },
                                [
                                  _c(
                                    VTooltip,
                                    {
                                      attrs: { "max-width": "400", top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  VBtn,
                                                  _vm._g(
                                                    {
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        color: "success",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.getRelatorio()
                                                        },
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(VIcon, [
                                                      _vm._v("get_app"),
                                                    ]),
                                                    _vm._v(" BAIXAR PDF "),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3286038400
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Clique para baixar o relatório dos dados em formato PDF."
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                [
                                  _c("app-alert", {
                                    attrs: {
                                      icon: "info",
                                      message: _vm.resultadoInviabilizado,
                                      type: "info",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }